import { StringValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { nonEmptyString, requiredTrackingId, validatePayload, } from '../../../utils/validate-payload.js';
import { analyticsConfigurationSchema, } from '../../configuration/configuration-actions.js';
export const updateBasicConfiguration = createAction('commerce/configuration/updateBasicConfiguration', (payload) => validatePayload(payload, {
    accessToken: nonEmptyString,
    environment: new StringValue({
        required: false,
        constrainTo: ['prod', 'hipaa', 'stg', 'dev'],
    }),
    organizationId: nonEmptyString,
}));
export const updateProxyBaseUrl = createAction('commerce/configuration/updateProxyBaseUrl', (payload) => validatePayload(payload, {
    proxyBaseUrl: new StringValue({ required: false, url: true }),
}));
export const updateAnalyticsConfiguration = createAction('commerce/configuration/updateAnalyticsConfiguration', (payload) => {
    return validatePayload(payload, {
        enabled: analyticsConfigurationSchema.enabled,
        proxyBaseUrl: analyticsConfigurationSchema.proxyBaseUrl,
        source: analyticsConfigurationSchema.source,
        trackingId: requiredTrackingId,
    });
});
export const disableAnalytics = createAction('commerce/configuration/analytics/disable');
export const enableAnalytics = createAction('commerce/configuration/analytics/enable');
